import type { ResourceCategoryKey } from '@/features/virtual-resource/constants'
import { serializeVirtualResources } from '@/features/virtual-resource/persistence'
import type DataFileMap from '@/model/Resource/DataFileMap'

const KEYS: ResourceCategoryKey[] = ['audio', 'graphic', 'font', 'video']

export function virtualResourcesHasAny(
  roots: Partial<Record<ResourceCategoryKey, DataFileMap | null>>,
): boolean {
  return KEYS.some((k) => roots[k] != null)
}

/**
 * 将虚拟资源映射表 JSON 同步到云端。
 * 配置 `import.meta.env.VITE_CLOUD_VIRTUAL_RESOURCES_URL` 时，在合并保存等时机 POST（credentials携带 Cookie）。
 * 请求体为与 Data/virtual_resources.json 相同的 JSON 字符串。
 */
export async function uploadVirtualResourcesJsonIfConfigured(
  roots: Partial<Record<ResourceCategoryKey, DataFileMap | null>>,
): Promise<{ ok: boolean; skipped: boolean }> {
  const url = (import.meta.env.VITE_CLOUD_VIRTUAL_RESOURCES_URL as string | undefined)?.trim()
  if (!url) return { ok: true, skipped: true }
  if (!virtualResourcesHasAny(roots)) return { ok: true, skipped: true }

  const body = serializeVirtualResources(roots)
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    body,
    credentials: 'include',
  })
  if (!res.ok) {
    throw new Error(`虚拟资源映射上传失败：HTTP ${res.status}`)
  }
  return { ok: true, skipped: false }
}
